var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.301,
    y: 0.448,
    width: 21.3,
    height: 31.185,
    rx: 1.625,
    transform: "rotate(12.694 7.301 .448)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.614,
    y: 2.407,
    width: 21.3,
    height: 31.185,
    rx: 1.625,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.823 21.041H8.273c-.283 0-.472.189-.472.472s.189.471.472.471h11.503c.282 0 .471-.188.471-.471s-.189-.472-.424-.472zM19.823 23.634H8.273c-.283 0-.472.189-.472.472s.189.471.472.471h11.503c.282 0 .471-.188.471-.471s-.189-.472-.424-.472zM19.823 26.227H8.273c-.283 0-.472.189-.472.471 0 .283.189.472.472.472h11.503c.282 0 .471-.189.471-.472 0-.282-.189-.47-.424-.47zM13.677 28.645H8.032c-.138 0-.23.152-.23.38s.092.38.23.38h5.622c.138 0 .23-.152.23-.38s-.092-.38-.207-.38zM19.448 9.789h-2.352V7.438a.6.6 0 0 0-.594-.595h-3.837a.6.6 0 0 0-.595.595v2.35H9.719a.6.6 0 0 0-.595.595v3.838a.6.6 0 0 0 .595.594h2.351v2.351a.6.6 0 0 0 .595.595h3.837a.6.6 0 0 0 .595-.595v-2.35h2.35a.6.6 0 0 0 .595-.595v-3.838a.583.583 0 0 0-.594-.594zm-.568 3.837H16.53a.6.6 0 0 0-.595.595v2.351H13.26v-2.351a.6.6 0 0 0-.595-.595h-2.35v-2.675h2.35a.6.6 0 0 0 .595-.595v-2.35h2.675v2.35a.6.6 0 0 0 .595.595h2.351v2.675z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 13.626h-2.35a.6.6 0 0 0-.595.595v2.351h-2.676v-2.351a.6.6 0 0 0-.594-.595h-2.351v-2.675h2.35a.6.6 0 0 0 .595-.595v-2.35h2.676v2.35a.6.6 0 0 0 .594.595h2.351v2.675z",
    fill: "#F2B543"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documents-icon.98542c2daa3f6666fa80a9696c1c7a09.svg";
export { ForwardRef as ReactComponent };